<template>
  <div class="core-service">
    <div
      class="core-service_banner"
      :style="{
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(' +
          require('../../../assets/images/core-service/' + imgUrl + '.png') +
          ')',
      }"
    >
      <h2 class="core-service_banner_title">
        {{ nameUrl }}
      </h2>
      <div class="core-service_banner_sub-title">Why us</div>
    </div>
    <tabs @name="setName">
      <tab name="lcl-consol" :selected="true">
        <LclConsol />
      </tab>
      <tab name="domestic-transport">
        <domestic-transport />
      </tab>
      <tab name="container&-van-truck">
        <container-van-truck />
      </tab>
      <tab name="customs-broker">
        <customs-broker />
      </tab>
    </tabs>
  </div>
</template>

<script>
import { reactive, ref, computed } from "@vue/composition-api";
// import { useRoute } from "vue-router";
export default {
  name: "WhyUs",
  components: {
    Tabs: () => import("@/@core/components/tabs"),
    Tab: () => import("@/@core/components/tab"),
    LclConsol: () => import("./components/lcl-consol"),
    DomesticTransport: () => import("./components/domestic-transport"),
    ContainerVanTruck: () => import("./components/container-van-truck"),
    CustomsBroker: () => import("./components/customs-broker"),
  },

  setup(props) {

    
    const onNameUrl = ref("");
    const dataCoreService = reactive({
      "core-service": {
        name: "lcl consol",
        img: "lcl-consol",
      },
      "domestic-transport": {
        name: "domestic transport",
        img: "domestic-transport",
      },
      "container&-van-truck": {
        name: "container& van truck",
        img: "container&-van-truck",
      },
      "customs-broker": {
        name: "customs broker",
        img: "customs-broker",
      },
    });
    // console.log(route);
    function setName(name) {
      onNameUrl.value = name;
    }
    const imgUrl = computed(
      () => dataCoreService[onNameUrl.value]?.img || "lcl-consol"
    );

    const nameUrl = computed(
      () => dataCoreService[onNameUrl.value]?.name || "lcl consol"
    );

    return {
      dataCoreService,
      setName,
      onNameUrl,
      imgUrl,
      nameUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/style.scss";
.core-service {
  height: 100%;
  &_banner {
    height: 413px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    &_title {
      text-align: center;
      position: absolute;
      text-transform: uppercase;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      font-weight: 900;
      font-size: var(--big-font-size);
      line-height: 45px;
      text-align: center;
      letter-spacing: 0.155em;

      color: #ffffff;
    }
    &_sub-title {
      font-weight: 600;
      font-size: var(--normal-font-size);
      line-height: 22px;
      letter-spacing: -0.02em;
      position: absolute;
      bottom: 3%;
      left: 0%;
      color: #2b938c;
      background: #f8f7f7;
      padding: 10px 40px;
      width: 100%;
    }
  }
  h1 {
    text-align: center;
    font-weight: 900;
    font-size: var(--big-font-size);
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.155em;
    color: #2b938c;
    padding: 100px;
  }
}
</style>